import { Model } from '@vuex-orm/core'
// import store from '@/store'

export default class BaseModel extends Model {
  
}



// WEBPACK FOOTER //
// ./src/store/models/Model.js